<template>
    <div class="submenu-grid">
        <div v-if="showCount" class="submenu-grid__summary">
            <div class="ws-stat" aria-live="polite">
                <strong>{{ items.length }}</strong>
                <span>{{ countLabel }}</span>
            </div>
        </div>
        <div class="submenu-grid__items">
            <div
                v-for="(item, index) in items"
                :key="item.key || `${routeKey(item.to || item.path)}-${index}`"
                class="submenu-grid__item shrink"
            >
                <router-link
                    :to="item.to || item.path"
                    class="submenu-grid__link"
                >
                    <div
                        class="card bg-gradient-success submenu-grid__card"
                        :class="{ 'submenu-grid__card--has-count': hasCount(item.count) }"
                    >
                        <span
                            v-if="hasCount(item.count)"
                        class="ws-stat submenu-grid__badge"
                        >
                        <strong>{{ displayCount(item.count) }}</strong>
                        </span>
                        <div class="card-body">
                            <div class="icon icon-shape bg-white text-dark rounded-circle shadow mb-2">
                                <i :class="item.icon || 'fa fa-folder'" aria-hidden="true"></i>
                            </div>
                            <h5 class="card-title text-muted mb-0 text-white">
                                {{ item.title }}
                            </h5>
                            <p class="card-description">{{ item.description }}</p>
                        </div>
                    </div>
                </router-link>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "SubmenuGrid",
    inject: {
        setSubmenuCount: { default: null }
    },
    props: {
        items: {
            type: Array,
            required: true
        },
        countLabel: {
            type: String,
            default: "menu items"
        },
        showCount: {
            type: Boolean,
            default: true
        }
    },
    methods: {
        routeKey(route) {
            return typeof route === "string" ? route : JSON.stringify(route);
        },
        hasCount(value) {
            return value !== null && value !== undefined && value !== "";
        },
        displayCount(value) {
            const count = Number(value);
            if (!Number.isFinite(count)) return value;
            const normalized = Math.max(0, Math.floor(count));
            return normalized > 99 ? "99+" : normalized;
        }
    },
    watch: {
        items: {
            immediate: true,
            handler(items) {
                if (this.setSubmenuCount) {
                    this.setSubmenuCount(Array.isArray(items) ? items.length : 0);
                }
            }
        }
    }
};
</script>

<style scoped>
.submenu-grid {
    padding: 1.1rem 1.25rem 1.25rem;
    background-color: #fff;
}

.submenu-grid__summary {
    display: flex;
    justify-content: flex-end;
    margin-bottom: 1rem;
}

.submenu-grid__summary .ws-stat {
    margin: 0;
    flex: 0 0 auto;
}

.submenu-grid__items {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(min(100%, 260px), 1fr));
    gap: 1rem;
    align-items: stretch;
}

.submenu-grid__item {
    min-width: 0;
    margin: 0;
}

.submenu-grid__link {
    display: block;
    height: 100%;
    color: inherit;
    text-decoration: none;
}

.submenu-grid__card {
    height: 100%;
}

.submenu-grid__card--has-count::after {
    display: none;
}

.submenu-grid__badge {
    position: absolute;
    z-index: 1;
    top: 1rem;
    right: 1rem;
    min-width: 1.65rem;
    justify-content: center;
    padding: 0.25rem 0.5rem;
    flex: 0 0 auto;
    line-height: 1.2;
}

.submenu-grid__badge strong {
    font-size: 0.8rem;
}

.submenu-grid__card--has-count .card-title {
    padding-right: 2.5rem;
}

@media (max-width: 575.98px) {
    .submenu-grid {
        padding: 0.8rem 0.55rem 1rem;
    }

    .submenu-grid__items {
        grid-template-columns: minmax(0, 1fr);
        gap: 0.75rem;
    }

    .submenu-grid__summary {
        margin-bottom: 0.75rem;
    }
}
</style>
